export const activities = state => state.activities.items
export const activityById = state => id => _.find(activities(state), {id})
export const activityReferenceById = (state, getters) => (type, id) => {
    switch (type) {
        case 'project':
            return getters.projectById(id)
        case 'proposal':
            return getters.proposalById(id)
        case 'change-order':
            return getters.changeOrderById(id)
        case 'contact':
            return getters.contactById(id)
        case 'note':
            return getters.noteById(id)
        case 'task':
            return getters.taskById(id)
    }
}
export const activityDescriptionById = (state, getters) => (type, id) => {
    switch (type) {
        case 'project':
            return (getters.projectById(id) || {}).full_name
        case 'proposal':
            return (getters.proposalById(id) || {}).project_name
        case 'change-order':
            return (getters.changeOrderById(id) || {}).number
        case 'contact':
            return (getters.contactById(id) || {}).full_name
        case 'note':
            return (getters.noteById(id) || {}).message
        case 'task':
            return (getters.taskById(id) || {}).description
    }
}
export const activitiesByIds = state => ids => {
    return _.reduce(ids, (res, id) => {
        let activity = activityById(state)(id)
        if (activity) res.push(activity)
        return res
    }, [])
}
